export default __webpack_public_path__ + "static/media/nfl-player-mobile.61d9d6be.png";